module.exports = __webpack_public_path__ + "media/KZ-KUS.678fb527.ogg";